<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div>
      <ElevatorsMap />
    </div>
  </div>
</template>

<script>
import ElevatorsMap from '@/components/ElevatorsMap.vue'
export default {
  name: 'Home',
  components: {
    ElevatorsMap
  }
}
</script>

<style>
.home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  /* height: 60vh; */
}
</style>